'use client';

import { useLiteMode } from '@/hooks/useLiteMode.hook';
import { useMediaQuery } from '@/hooks/useMediaQuery.hook';
import { MAIN_XL_MAX_QUERY } from '@/constants/main';
import ScrollStage from './_components/scroll-stage';
import AnimatedReanalysis from './_components/reanalysis-animation';
import MobileReanalysis from './_components/reanalysis-mobile';
import { ReanalysisFallback } from './_components/reanalysis-content';

export default function ReanalysisSection() {
  const isLiteMode = useLiteMode();
  const isMobile = useMediaQuery(MAIN_XL_MAX_QUERY);
  return (
    <section data-main-reanalysis>
      {isLiteMode ? (
        <ReanalysisFallback />
      ) : (
        <ScrollStage
          heightVh={600}
          endHoldPx={400}
          // 장면은 고정 캔버스(모바일 390×600·데스크톱 1920×1080)를 화면에 맞춰 축소해 그리므로
          // 높이 제한 없이 항상 고정한다 — 높이 문턱을 두면 툴바·배너·DevTools 가 높이를
          // 잡아먹는 창에서 카드 장면이 통째로 빠진다
          minContentPx={0}
          mobileUnderHeader
          className="[clip-path:inset(0)]"
        >
          {(progress, isSticky) =>
            isSticky ? (
              isMobile ? (
                <MobileReanalysis progress={progress} />
              ) : (
                <AnimatedReanalysis progress={progress} />
              )
            ) : (
              <ReanalysisFallback />
            )
          }
        </ScrollStage>
      )}
    </section>
  );
}
